import { Store } from "../../../flux/Store";
import { names } from "./DeleteObjectsActions";
import { Key, EntityType } from "../../../models";
import { assertArray } from "../../utils/assert";

export interface DeleteObjectsStoreState
{
    isConfirmationDialogShown: boolean;
    ids: Key[];

    errorMessage?: string;
}

export class DeleteObjectsStore extends Store<DeleteObjectsStoreState>
{
    constructor(private entityType: EntityType)
    {
        super();
        this.state = {
            isConfirmationDialogShown: false,
            ids: []
        };

        this.register<Key[]>(names.SET_IDS, e => {
            if(e.meta === this.entityType) {
                const ids = e.payload;
                assertArray(ids, 'expected Array payload');
                return this.field({ ids });
            }
        });
        this.register(names.SHOW_CONFIRMATION, e => {
            if(e.meta === this.entityType) {
                return this.field({ isConfirmationDialogShown: true, errorMessage: null });
            }
        });
        this.register(names.HIDE_CONFIRMATION, e => {
            if(e.meta === this.entityType) {
                return this.field({ isConfirmationDialogShown: false, errorMessage: null });
            }
        });
        this.register<Error>(names.ERROR, e => {
            if(e.meta === this.entityType) {
                return this.field({ errorMessage: e.payload.message });
            }
        });
    }    
}


// WEBPACK FOOTER //
// ./src/app/flux/DeleteObjects/DeleteObjectsStore.ts